// Job status helper functions

export const getJobStatus = (jobData: any) => {
  // Check if this is the new data model (has runState property)
  if (jobData.runState !== undefined) {
    return jobData.runState
  }

  // Old data model - determine state from job counts
  const countJobsStart = jobData.countJobsStart || 0
  const countJobsDone = jobData.countJobsDone || 0
  const countJobsCancel = jobData.countJobsCancel || 0
  const countJobsError = jobData.countJobsError || 0

  // If there are errors, return ERROR
  if (countJobsError > 0) {
    return 'ERROR'
  }

  // If there are canceled jobs, return CANCELED
  if (countJobsCancel > 0) {
    return 'CANCELED'
  }

  // If all started jobs are done, return DONE
  if (countJobsDone >= countJobsStart) {
    return 'DONE'
  }

  // If no jobs have started, return RUNNING (initial state)
  if (countJobsStart === 0) {
    return 'RUNNING'
  }

  // Otherwise, still running
  return 'RUNNING'
}

/** States that should appear on the dashboard while a job has not finished. */
const IN_PROGRESS_STATES = new Set(['QUEUED', 'INITIALIZING', 'PENDING', 'RUNNING'])

export const isJobInProgress = (jobData: any) => IN_PROGRESS_STATES.has(getJobStatus(jobData))

export const isJobFinished = (jobData: any) => {
  const status = getJobStatus(jobData)
  return (
    status === 'COMPLETE' ||
    status === 'DONE' ||
    status === 'CANCELED' ||
    status === 'CANCELING' ||
    status === 'PREEMPTED' ||
    status === 'EXECUTOR_ERROR' ||
    status === 'SYSTEM_ERROR'
  )
} 